(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
/* Use higher-density CDN variants for mobile images without responsive sources.
   Existing responsive images and external supplier URLs remain intact. */
function megMobileImageSources() {
 if (!window.matchMedia('(max-width:749px)').matches) return;
 document.querySelectorAll('img[src]:not([srcset])').forEach(image => {
  if (image.closest('picture')) return;
  const url = new URL(image.getAttribute('src'), location.href);
  if (!(url.hostname === 'cdn.shopify.com' || (url.origin === location.origin && url.pathname.startsWith('/cdn/shop/')))) return;
  const width = image.getBoundingClientRect().width;
  if (!width || !url.searchParams.has('width')) return;
  image.sizes = Math.ceil(width) + 'px';
  image.srcset = [192, 384, 640, 960, 1200].map(size => {
   const variant = new URL(url.href); variant.searchParams.set('width', size);
   return variant.href + ' ' + size + 'w';
  }).join(', ');
 });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', megMobileImageSources, {once:true});
else megMobileImageSources();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meg-budget-intro"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('meg-budget-example'))customElements.define('meg-budget-example',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('change',()=>{let remaining=55;this.querySelectorAll('input:checked').forEach(i=>remaining-=Number(i.value));this.querySelector('output').textContent=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(remaining);});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meg-product-ring"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const INTERVAL = 4500;
  const PRODUCT_INTERVAL = 3000;

  class ProductRing extends HTMLElement {
    #index = 0;
    #intent = true;
    #hovered = false;
    #focused = false;
    #visible = true;
    #gesture;
    #suppressClickUntil = 0;
    #timer;
    #productTimer;
    #productEpoch = 0;
    #controller;
    #resize;
    #intersection;
    #media;
    #awayAt = 0;
    #restored = false;
    #savedState;

    connectedCallback() {
      if (this.#controller) return;
      this.#controller = new AbortController();
      this.removeAttribute('data-ready');
      const { signal } = this.#controller;
      this.labels = JSON.parse(this.querySelector('[data-ring-labels]').textContent);
      this.tiles = [...this.querySelectorAll('.ring-tile')];
      this.products = JSON.parse(this.querySelector('[data-ring-products]').textContent);
      this.productIndexes = Object.fromEntries(Object.keys(this.products).map(key => [key, 0]));
      this.failedImages = new Set();
      this.catalogueLoaded = false; this.catalogueLoading = false; this.#restored = false;
      this.stage = this.querySelector('[data-stage]');
      this.stage.tabIndex = 0;
      this.stage.setAttribute('aria-label', this.labels.stage_label);
      this.querySelector('[data-instructions]').textContent = this.labels.instructions;
      this.motionButton = this.querySelector('[data-motion-button]');
      this.#media = matchMedia('(prefers-reduced-motion: reduce)');
      try {
        const saved = JSON.parse(sessionStorage.getItem('meg:ring:featured:v3') || 'null');
        if (saved && Date.now() - saved.time < 86400000 && Date.now() >= saved.time) {
          this.#savedState = saved;
          this.#index = Math.max(0, Number(saved.index) || 0) % this.tiles.length;
          this.#intent = saved.playing !== false;
        }
      } catch {}
      this.querySelector('[data-dots]').replaceChildren(...this.tiles.map(() => document.createElement('span')));
      this.querySelector('[data-controls]').hidden = false;
      this.setAttribute('data-enhanced', '');
      this.#focused = this.contains(document.activeElement);
      this.#hovered = matchMedia('(hover: hover)').matches && this.matches(':hover');

      this.motionButton.addEventListener('click', () => { this.#intent = !this.#intent; this.#schedule(); }, { signal });
      this.querySelector('[data-previous]').addEventListener('click', () => this.#move(-1, true), { signal });
      this.querySelector('[data-next]').addEventListener('click', () => this.#move(1, true), { signal });
      this.addEventListener('focusin', () => { this.#focused = true; this.#schedule(); }, { signal });
      this.addEventListener('focusout', () => queueMicrotask(() => {
        if (!this.isConnected) return;
        this.#focused = this.contains(document.activeElement);
        this.#schedule();
      }), { signal });
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch') return;
        this.#hovered = true; this.#schedule();
      }, { signal });
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'touch') return;
        this.#hovered = false; this.#schedule();
      }, { signal });
      this.stage.addEventListener('keydown', event => {
        const steps = { ArrowLeft: -1, ArrowRight: 1, Home: -this.#index, End: this.tiles.length - 1 - this.#index };
        if (!(event.key in steps) || event.altKey || event.ctrlKey || event.metaKey) return;
        event.preventDefault();
        const tileFocused = event.target.matches('[data-select]');
        this.#move(steps[event.key], true);
        if (tileFocused) this.tiles[this.#index].querySelector('[data-select]').focus({ preventScroll: true });
      }, { signal });
      window.addEventListener('click', event => {
        if (this.stage.contains(event.target) && event.detail && performance.now() < this.#suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, { signal, capture: true });
      this.stage.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        this.#gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
        this.#schedule();
      }, { signal });
      window.addEventListener('pointerup', event => {
        if (event.pointerId !== this.#gesture?.id) return;
        const dx = event.clientX - this.#gesture.x;
        const dy = event.clientY - this.#gesture.y;
        this.#gesture = undefined;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          this.#suppressClickUntil = performance.now() + 350;
          this.#move(dx < 0 ? 1 : -1, true);
        } else this.#schedule();
      }, { signal });
      window.addEventListener('pointercancel', event => {
        if (event.pointerId !== this.#gesture?.id) return;
        this.#gesture = undefined; this.#schedule();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) { this.#awayAt = Date.now(); this.#saveState(); }
        else this.#catchUp();
        this.#schedule();
      }, { signal });
      window.addEventListener('pagehide', () => this.#saveState(), { signal });
      window.addEventListener('pageshow', event => { if (event.persisted) { this.#catchUp(); this.#schedule(); } }, { signal });
      this.#media.addEventListener('change', () => this.#schedule(), { signal });
      this.#resize = new ResizeObserver(() => this.#render());
      this.#resize.observe(this.stage);
      this.#intersection = new IntersectionObserver(entries => {
        const wasVisible = this.#visible;
        this.#visible = entries[0].isIntersecting;
        if (!this.#visible && wasVisible) this.#awayAt = Date.now();
        if (this.#visible && !wasVisible) this.#catchUp();
        if (this.#visible) this.#loadCatalogue();
        this.#schedule();
      }, { threshold: 0 });
      this.#intersection.observe(this);
      this.#render();
      getComputedStyle(this.tiles[0]).transform;
      this.setAttribute('data-ready', '');
      this.#schedule();
    }

    disconnectedCallback() {
      this.#saveState();
      clearTimeout(this.#timer);
      clearTimeout(this.#productTimer);
      this.#productTimer = undefined;
      this.#productEpoch++;
      this.#gesture = undefined;
      this.#controller?.abort();
      this.#resize?.disconnect();
      this.#intersection?.disconnect();
      this.#controller = undefined;
    }

    async #loadCatalogue() {
      if (this.catalogueLoaded || this.catalogueLoading) return;
      this.catalogueLoading = true;
      const signal = this.#controller.signal;
      try {
        const featured = this.querySelector('[data-featured-products]');
        const data = featured ? JSON.parse(featured.textContent) : await (await import(new URL(this.labels.feed_loader, location.href).href)).loadPreviewCatalogue([this.labels.catalogue_url, this.labels.extra_catalogue_url]);
        if (signal.aborted || !this.isConnected || !Array.isArray(data.items)) return;
        for (const department of Object.keys(this.products)) {
          const rows = data.items.filter(item => item.department === department);
          const byAnchor = new Map(rows.map(item => [item.anchor, item]));
          const initial = this.products[department].map(item => byAnchor.get(item.anchor)).filter(Boolean);
          const existing = new Set(initial.map(item => item.anchor));
          this.products[department] = [...initial, ...rows.filter(item => !existing.has(item.anchor))];
          const saved = this.#savedState;
          const previous = saved?.products?.[department];
          const rowsNow = this.products[department];
          let index = previous ? rowsNow.findIndex(item => item.sku === previous.sku) : -1;
          if (index < 0) index = previous ? Math.max(0, Number(previous.index) || 0) % Math.max(1, rowsNow.length) : Math.floor(Math.random() * rowsNow.length);
          const elapsed = saved && this.#intent && !this.#media.matches ? Math.floor(Math.max(0, Date.now() - saved.time) / PRODUCT_INTERVAL) : 0;
          this.productIndexes[department] = (index + elapsed) % Math.max(1, rowsNow.length);
          const tile = this.tiles.find(tile => tile.dataset.department === department);
          if (tile && rowsNow.length) this.#paintProduct(tile, rowsNow[this.productIndexes[department]], this.productIndexes[department]);
        }
        for (const tile of this.tiles) {
          const item = this.products[tile.dataset.department][this.productIndexes[tile.dataset.department]];
          if (item?.nativeUrl) {
            tile.dataset.studioVariant = String(item.nativeVariantId);
            tile.dataset.studioUrl = item.nativeUrl;
          }
        }
        this.catalogueLoaded = true;
        if (!this.#restored && this.#savedState && this.#intent && !this.#media.matches) this.#index = (this.#index + Math.floor(Math.max(0, Date.now() - this.#savedState.time) / INTERVAL)) % this.tiles.length;
        this.#restored = true;
        this.#savedState = undefined;
        this.#awayAt = 0;
        this.#render();
        this.#updateDiscoveryLinks();
        this.dispatchEvent(new CustomEvent('meg:studio-render', {bubbles:true}));
        this.dataset.catalogueSize = String(Object.values(this.products).reduce((sum, group) => sum + group.length, 0));
        for (const tile of this.tiles) {
          const count = this.products[tile.dataset.department].length;
          const index = this.productIndexes[tile.dataset.department];
          tile.querySelector('[data-cycle-count]').textContent = `${index + 1} / ${count}`;
        }
      } catch {
        this.dataset.catalogueState = 'fallback';
        // The six curated previews per department remain usable if the larger catalogue is unavailable.
      } finally { this.catalogueLoading = false; }
    }

    #scheduleProducts(running) {
      if (!running) {
        clearTimeout(this.#productTimer);
        this.#productTimer = undefined;
        this.#productEpoch++;
        return;
      }
      if (this.#productTimer) return;
      const epoch = this.#productEpoch;
      this.#productTimer = setTimeout(async () => {
        // Keep this handle during image decoding so a ring step cannot create a second clock.
        try { await this.#cycleProducts(epoch); }
        finally {
          if (epoch !== this.#productEpoch) return;
          this.#productTimer = undefined;
          this.#scheduleProducts(this.dataset.running === 'true');
        }
      }, PRODUCT_INTERVAL);
    }

    async #cycleProducts(epoch) {
      await Promise.all(this.tiles.map(async (tile, position) => {
        const department = tile.dataset.department;
        const products = this.products[department] || [];
        if (products.length < 2) return;
        let index = this.productIndexes[department];
        let product;
        for (let attempt = 0; attempt < products.length; attempt++) {
          index = (index + 1) % products.length;
          product = products[index];
          if (!this.failedImages.has(product.sku)) break;
        }
        if (!product || this.failedImages.has(product.sku)) return;
        const source = new URL(product.image, location.origin);
        if (source.hostname.endsWith('shopify.com') || source.pathname.includes('/cdn/shop/')) source.searchParams.set('width', '480');
        const preload = new Image();
        preload.src = source.href;
        try { await preload.decode(); }
        catch { this.failedImages.add(product.sku); return; }
        if (!this.isConnected || this.#controller?.signal.aborted || epoch !== this.#productEpoch || this.dataset.running !== 'true') return;
        this.#paintProduct(tile, product, index, source.href);
      }));
      if (epoch === this.#productEpoch && this.isConnected) this.#updateDiscoveryLinks();
    }

    #paintProduct(tile, product, index, source = product.image) {
      const image = tile.querySelector('img');
      const url = new URL(source, location.origin);
      if (url.protocol !== 'https:' || !(url.origin === location.origin || url.hostname === 'cdn.shopify.com')) return;
      url.searchParams.set('width', '480');
      tile.querySelector('meg-studio-picture')?.reset();
      image.src = url.href; image.removeAttribute('srcset'); image.alt = product.title;
      tile.querySelector('.tile-title').textContent = product.title;
      tile.querySelector('.tile-kind').textContent = this.labels.planned_price.replace('__price__', new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(product.amount / 100));
      const counter = tile.querySelector('[data-cycle-count]');
      counter.textContent = `${index + 1} / ${this.products[tile.dataset.department].length}`;
      counter.setAttribute('aria-label', this.labels.product_count.replace('__position__', index + 1).replace('__count__', this.products[tile.dataset.department].length));
      tile.dataset.productAnchor = product.anchor; tile.dataset.sku = product.sku;
      tile.dataset.studioVariant = String(product.nativeVariantId || ''); tile.dataset.studioUrl = product.nativeUrl || '';
      tile.querySelector('[data-select]').href = this.#productURL(tile);
      tile.setAttribute('aria-label', this.labels.slide_label.replace('__position__', this.tiles.indexOf(tile) + 1).replace('__count__', this.tiles.length).replace('__title__', product.title));
      this.productIndexes[tile.dataset.department] = index;
      this.dispatchEvent(new CustomEvent('meg:studio-render', {bubbles:true}));
    }

    #saveState() {
      if (!this.tiles || !this.catalogueLoaded) return;
      const products = Object.fromEntries(Object.keys(this.products).map(department => [department, {index:this.productIndexes[department],sku:this.products[department][this.productIndexes[department]]?.sku}]));
      try { sessionStorage.setItem('meg:ring:featured:v3', JSON.stringify({time:this.#awayAt || Date.now(),index:this.#index,playing:this.#intent,products})); } catch {}
    }

    #catchUp() {
      if (!this.#awayAt || !this.catalogueLoaded || this.#focused || this.#hovered) return;
      const elapsed = Math.min(86400000, Math.max(0, Date.now() - this.#awayAt));
      this.#awayAt = 0;
      if (!this.#intent || this.#media.matches) return;
      this.#index = (this.#index + Math.floor(elapsed / INTERVAL)) % this.tiles.length;
      for (const tile of this.tiles) {
        const rows = this.products[tile.dataset.department];
        if (!rows?.length) continue;
        const index = (this.productIndexes[tile.dataset.department] + Math.floor(elapsed / PRODUCT_INTERVAL)) % rows.length;
        this.#paintProduct(tile, rows[index], index);
      }
      this.#render();
    }

    #productURL(tile) {
      const url = new URL(tile.dataset.studioUrl || this.dataset.rootUrl + 'collections/all', location.origin);
      if (!tile.dataset.studioUrl) url.searchParams.set('view', tile.dataset.departmentView);
      const previewId = new URL(location.href).searchParams.get('preview_theme_id');
      if (previewId) url.searchParams.set('preview_theme_id', previewId);
      if (!tile.dataset.studioUrl) url.hash = tile.dataset.productAnchor;
      return url;
    }

    #updateDiscoveryLinks() {
      for (const tile of this.tiles) tile.querySelector('[data-select]').href = this.#productURL(tile);
      const productURL = this.#productURL(this.tiles[this.#index]);
      this.querySelector('[data-ring-view-product]').href = productURL;
      const departmentURL = new URL(this.dataset.rootUrl + 'collections/all', location.origin); departmentURL.searchParams.set('view', this.tiles[this.#index].dataset.departmentView);
      const previewId = new URL(location.href).searchParams.get('preview_theme_id'); if (previewId) departmentURL.searchParams.set('preview_theme_id', previewId);
      this.querySelector('[data-ring-view-department]').href = departmentURL;
    }

    #move(step, manual) {
      this.#index = (this.#index + step + this.tiles.length) % this.tiles.length;
      if (manual) {
        this.#intent = false;
        this.querySelector('[data-announcement]').textContent = this.labels.announcement.replace('__position__', this.#index + 1).replace('__count__', this.tiles.length).replace('__title__', this.tiles[this.#index].querySelector('.tile-title').textContent);
      }
      this.#render();
      this.#schedule();
    }

    #render() {
      const width = this.stage.clientWidth;
      const roomy = matchMedia('(min-width: 901px)').matches;
      const tileWidth = Math.min(roomy ? 264 : 228, Math.max(140, width * .46));
      const radiusX = Math.min(roomy ? 370 : 320, width * .32, (width - tileWidth * .84) / 2 - 12);
      const radiusY = Math.min(62, width * .085, Math.max(16, (this.stage.clientHeight - tileWidth / .76) / 2 - 15));
      this.style.setProperty('--meg-ring-tile-width', `${tileWidth}px`);
      this.tiles.forEach((tile, i) => {
        const angle = (i - this.#index) * Math.PI * 2 / this.tiles.length;
        const depth = (Math.cos(angle) + 1) / 2;
        tile.style.transform = `translate(-50%, -50%) translate3d(${Math.sin(angle) * radiusX}px, ${Math.cos(angle) * radiusY}px, 0) rotate(${Math.sin(angle) * 12}deg) scale(${.66 + depth * .34})`;
        tile.style.opacity = String(.88 + depth * .12);
        tile.style.zIndex = String(Math.round(depth * 10) + 1);
        tile.dataset.front = String(i === this.#index);
        const button = tile.querySelector('[data-select]');
        button.tabIndex = i === this.#index ? 0 : -1;
        const imageSwitch = tile.querySelector('.meg-studio-switch'); if (imageSwitch) imageSwitch.tabIndex = button.tabIndex;
      });
      this.#updateDiscoveryLinks();
      this.querySelector('[data-position]').textContent = String(this.#index + 1).padStart(2, '0');
      [...this.querySelector('[data-dots]').children].forEach((dot, i) => dot.toggleAttribute('data-active', i === this.#index));
      this.dataset.active = String(this.#index);
    }

    #schedule() {
      clearTimeout(this.#timer);
      const reduced = this.#media.matches;
      const running = this.#intent && !reduced && !this.#focused && !this.#hovered && !this.#gesture && !document.hidden && this.#visible;
      this.dataset.running = String(running);
      this.dataset.motion = reduced ? 'reduced' : 'standard';
      this.motionButton.disabled = reduced;
      this.motionButton.setAttribute('aria-label', reduced ? this.labels.play_reduced : this.#intent ? this.labels.pause : this.labels.play);
      this.querySelector('[data-motion-label]').textContent = reduced || !this.#intent ? this.labels.label_play : this.labels.label_pause;
      this.querySelector('[data-play-icon]').toggleAttribute('hidden', this.#intent && !reduced);
      this.querySelector('[data-pause-icon]').toggleAttribute('hidden', !this.#intent || reduced);
      this.querySelector('[data-motion-state]').textContent = reduced ? this.labels.state_reduced : !this.#intent ? this.labels.state_paused : this.#focused ? this.labels.state_focus : this.#hovered || this.#gesture ? this.labels.state_interaction : document.hidden ? this.labels.state_hidden : !this.#visible ? this.labels.state_offscreen : this.labels.state_running;
      this.#scheduleProducts(running);
      if (running) this.#timer = setTimeout(() => this.#move(1, false), INTERVAL);
    }
  }

  if (!customElements.get('meg-product-ring')) customElements.define('meg-product-ring', ProductRing);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meg-seasonal-discovery"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('meg-seasonal-rotator')) return;
  class MEGSeasonalRotator extends HTMLElement {
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();const signal=this.controller.signal;
      this.slides=Array.from(this.querySelectorAll('[data-seasonal-slide]'));if(!this.slides.length)return;
      this.index=0;this.playing=true;this.focused=false;this.hovered=false;this.visible=true;
      this.reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.toggle=this.querySelector('[data-seasonal-toggle]');this.status=this.querySelector('[data-seasonal-status]');
      this.interval=Math.max(5000,Math.min(15000,Number(this.dataset.interval)||6500));
      this.querySelector('[data-seasonal-prev]').addEventListener('click',()=>this.move(-1,true),{signal});
      this.querySelector('[data-seasonal-next]').addEventListener('click',()=>this.move(1,true),{signal});
      this.toggle.addEventListener('click',()=>{this.playing=!this.playing;this.draw(false);},{signal});
      this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule();},{signal});
      this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();},{signal});
      this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},{signal});
      this.addEventListener('focusout',()=>{this.focused=this.contains(document.activeElement);this.schedule();},{signal});
      if(this.reduce.addEventListener)this.reduce.addEventListener('change',()=>this.schedule(),{signal});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0]?.isIntersecting??false;this.schedule();},{threshold:0.15});this.observer.observe(this);
      this.draw(false);
    }
    disconnectedCallback(){clearTimeout(this.timer);this.observer?.disconnect();this.controller?.abort();this.controller=null;}
    move(delta,announce){this.index=(this.index+delta+this.slides.length)%this.slides.length;this.draw(announce);}
    draw(announce){this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;slide.setAttribute('aria-hidden',i!==this.index?'true':'false');});this.querySelector('[data-seasonal-progress]').textContent=`${this.index+1} / ${this.slides.length}`;this.style.setProperty('--meg-seasonal-progress',`${((this.index+1)/this.slides.length)*100}%`);this.toggle.textContent=this.playing?'Pause':'Play';this.toggle.setAttribute('aria-label',this.playing?'Pause seasonal rotation':'Play seasonal rotation');this.toggle.setAttribute('aria-pressed',String(!this.playing));if(announce)this.status.textContent='Showing '+this.slides[this.index].querySelector('h4').textContent;this.schedule();}
    schedule(){clearTimeout(this.timer);if(!this.controller||!this.playing||this.reduce.matches||this.hovered||this.focused||!this.visible||this.slides.length<2)return;this.timer=setTimeout(()=>this.move(1,false),this.interval);}
  }
  customElements.define('meg-seasonal-rotator',MEGSeasonalRotator);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
function restoreMegFilters(){const params=new URLSearchParams(window.location.search);document.querySelectorAll('[data-meg-refine]').forEach(form=>{for(const key of ['filter.v.price.gte','filter.v.price.lte']){const field=form.elements.namedItem(key);if(field&&params.has(key))field.value=params.get(key)}const stock=form.elements.namedItem('filter.v.availability');if(stock)stock.checked=params.get('filter.v.availability')==='1'})}restoreMegFilters();document.addEventListener('shopify:section:load',restoreMegFilters);

  } catch(e) { console.error(e); }
})();
})();
